// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10UrG","label":"styles_label__1nyvc"};